module.exports = __webpack_public_path__ + "static/tigerstamp-c073756e60c1a269007a48243cddcc55.png";